import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectRequestMoreInfo } from "../../store/selectors/rectificationSelector";
import { Dialog } from "primereact/dialog";
import { setRequestMoreInfo } from "../../store/slices/rectificationSlice";
import { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { addDefectComment } from "../../store/thunks/rectificationThunks";
import { useNavigate } from "react-router-dom";
import { DEFECTS } from "../../types/RouteNames";

export const RequestMoreInfoDialog = () => {
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { defectId, inspectionId, showDialog } = useAppSelector(selectRequestMoreInfo);
    const [comment, setComment] = useState<string>("");

    const requestMoreInfoClose = () => {
        dispatch(setRequestMoreInfo({
            defectId: 0,
            inspectionId: "",
            showDialog: false,
        }));
        setComment("");
    }

    const requestMoreInfoSubmit = async () => {
        await dispatch(addDefectComment(defectId, inspectionId, comment))
        requestMoreInfoClose();
        navigate(`/${DEFECTS}`);
    };

    const requestMoreInfoFooter = (
        <div className="flex justify-content-center">
            <Button 
                label={t("defectRectification.requestInfoCancel")} 
                onClick={requestMoreInfoClose} 
                className="p-button-text md:w-8rem" 
            />
            <Button 
                label={t("defectRectification.requestInfoSubmit")} 
                onClick={requestMoreInfoSubmit} 
                className="p-button p-button-primary" 
                disabled={!comment}
            />
        </div>
    );

    return (
        <Dialog 
            header={t("defectRectification.requestInfoHeader")}
            footer={requestMoreInfoFooter}
            visible={showDialog}
            onHide={requestMoreInfoClose}
            className="dialog-medium"
        >
            <div>
                <span>{t("defectRectification.requestInfoDesc")}</span>
            </div>
            <div className="col-12 mt-4">
                <InputTextarea 
                    rows={8} 
                    value={comment} 
                    onChange={(e) => setComment(e.target.value)} 
                    placeholder={t("defectRectification.requestInfoPlaceholder")}
                    style={{ minWidth: "100%", maxWidth: "100%", minHeight: "100px"}}
                    autoResize
                    />
            </div>
        </Dialog>
    )
}